import React, { useState, useEffect } from 'react';
import { Textarea } from '@/components/ui/textarea';
import CoverImageStyleSelector from './CoverImageStyleSelector';

interface CoverImageGenerationContentProps {
  setDescription?: (desc: string) => void;
  setStyle?: (style: string) => void;
  initialDescription?: string;
  initialStyle?: string;
}

const CoverImageGenerationContent: React.FC<CoverImageGenerationContentProps> = ({ 
  setDescription,
  setStyle,
  initialDescription = '',
  initialStyle = 'style-photo'
}) => {
  const [description, setLocalDescription] = useState(initialDescription);
  const [selectedStyle, setSelectedStyle] = useState<string>(initialStyle);
  
  // Update parent component whenever values change
  useEffect(() => {
    if (setDescription) {
      setDescription(description);
    }
    if (setStyle) {
      setStyle(selectedStyle);
    }
  }, [description, selectedStyle, setDescription, setStyle]);
  
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newDescription = e.target.value;
    setLocalDescription(newDescription);
  };
  
  const handleStyleChange = (style: string) => {
    setSelectedStyle(style);
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Textarea
          id="description"
          placeholder="Describe your cover image (e.g., a modern office workspace with natural lighting, minimalist design)"
          value={description}
          onChange={handleDescriptionChange}
          className="min-h-[100px] resize-none"
        />
      </div>

      <CoverImageStyleSelector 
        selectedStyle={selectedStyle} 
        onSelectStyle={handleStyleChange}
      />
    </div>
  );
};

export default CoverImageGenerationContent;
